module.exports = __webpack_public_path__ + "img/love_invest_bg@2x.fddece4a.png";